import React from 'react';
import { useInView } from '../lib/useInView';

interface RevealProps {
  children: React.ReactNode;
  /** Stagger, in seconds. */
  delay?: number;
  className?: string;
}

/** Scroll-triggered entrance used throughout the page for a calm, staggered read. */
const Reveal: React.FC<RevealProps> = ({ children, delay = 0, className = '' }) => {
  const [ref, inView] = useInView<HTMLDivElement>();

  return (
    <div
      ref={ref}
      style={delay ? { transitionDelay: `${delay}s` } : undefined}
      className={`reveal ${inView ? 'is-visible' : ''} ${className}`}
    >
      {children}
    </div>
  );
};

export default Reveal;
